import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    usageChartData: {
        dates: [],
        hits: []
    },
    healthChartData: {
        total: '',
        data: []
    },
    initPieChart: false,
    initLineChart: false
}

const chartSlice = createSlice({
    initialState,
    name: 'chartSlice',
    reducers: {
        setUsageChartData: (state, action) => {
            state.usageChartData = action.payload
        },
        setHealthChartData: (state, action) => {
            state.healthChartData = action.payload
        },
        setInitPieChart: (state, action) => {
            state.initPieChart = action.payload
        },
        setInitLineChart: (state, action) => {
            state.initLineChart = action.payload
        }
    }
})

export const { setHealthChartData, setUsageChartData, setInitPieChart, setInitLineChart } = chartSlice.actions
export default chartSlice.reducer